import { QRLinks } from "./qr-listoflinks";

export { QRLinks };
